import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import GenericFormDrawer from '../../../components/GenericFormDrawer';

// Seçili ünvanlara toplu kademe / iş ailesi ataması (spec 2026-10-27 §7.1). `mode`: 'grade' | 'family'.
// AddToPoolDrawer deseni: GenericFormDrawer + sayılı not + tek seçici; "temizle" kutusu değeri boşaltır.
export const buildBatchBody = (mode, ids, formData) => {
  if (mode === 'grade') {
    if (formData.clear) return { ids, clearGrade: true };
    return formData.gradeId ? { ids, gradeId: formData.gradeId } : null;
  }
  if (formData.clear) return { ids, clearJobFamily: true };
  return formData.jobFamilyId ? { ids, jobFamilyId: formData.jobFamilyId } : null;
};

export default function TitleBatchAssignDrawer({ open, mode, ids, gradeAsync, familyAsync, onClose, onAssign }) {
  const { t } = useTranslation();
  const isGrade = mode === 'grade';

  const schema = useMemo(() => [
    { name: 'info', type: 'notice', content: t('title.batchAssignInfo', { count: ids.length }) },
    isGrade
      ? { name: 'gradeId', label: t('jobGrade.grade'), type: 'asyncSelect', ...gradeAsync }
      : { name: 'jobFamilyId', label: t('jobFamily.jobFamily'), type: 'asyncSelect', ...familyAsync },
    { name: 'clear', label: isGrade ? t('title.clearGrade') : t('title.clearJobFamily'), type: 'checkbox' },
  ], [t, ids.length, isGrade, gradeAsync, familyAsync]);

  const handleSave = async (formData) => {
    const body = buildBatchBody(mode, ids, formData);
    if (!body) return false;   // ne değer ne temizle seçildi — çekmece açık kalır
    const ok = await onAssign(body);
    if (ok) onClose();
    return ok;
  };

  return (
    <GenericFormDrawer
      open={open}
      onClose={onClose}
      title={isGrade ? t('title.assignGrade') : t('title.assignJobFamily')}
      schema={schema}
      initialValues={{}}
      onSave={handleSave}
    />
  );
}
